module.exports = __webpack_public_path__ + "img/binary.bf1f68b6.svg";